import Api from "./Api";

export const integrations = {
  ID06: "ID06",
  SsgSkillnation: "SsgSkillnation",
};

export async function loadActiveIntegrations() {
  let response;
  try {
    response = await Api.fetch(`${import.meta.env.VITE_MAIN_URL}settings/integrations/active`, false, "GET");
  } catch (e) {
    response = { isSuccessful: false };
  }

  if (response.isSuccessful) {
    const activeIntegrations = response.integrations.map((x) => x.name);
    sessionStorage.setItem("integrations", JSON.stringify(activeIntegrations));
  }
}

function getActiveIntegrations() {
  if (sessionStorage.integrations) {
    return new Set(JSON.parse(sessionStorage.integrations));
  }
  else {
    // It seems like the values are not available sometimes. This will reload them asynchronously,
    // so we won't be able to return the active integrations on this call. But next time this method
    // is called the values should be available, e.g. after rerendering UI. Let's see if this works well enough
    loadActiveIntegrations();
    return new Set();
  }
}

export function hasIntegration(integration) {
  const activeIntegrations = getActiveIntegrations();
  return activeIntegrations.has(integration);
}
